<template>
  <div id="app">
    <v-snackbar
      v-model="alert"
      top
      color=red
      :timeout=10000
    >
      {{alertText}}
      <v-btn
        flat
        @click="alert = false"
        >
        Close
      </v-btn>
    </v-snackbar>
    <v-toolbar id="toolbar">
          <v-toolbar-title>Kew Names Matching Service</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat dark  to="/">Simple</v-btn>
          <v-btn flat dark to="/csv">CSV</v-btn>
          <v-btn flat dark disabled to="/api">API</v-btn>
          <v-btn flat dark disabled to="/openrefine">OpenRefine</v-btn>
    </v-toolbar>
    <router-view/>
  </div>
</template>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#toolbar {
  background-color: #262522;
  color: white;
}
#toolbar a {
  color: white;
}
</style>
<script>
import {globalStore} from './main.js'
export default {
  computed: {
    alert: {
      get() {return globalStore.messageActive},
      set(value) { globalStore.messageActive = value }
    },
    alertText() {
      return globalStore.messageText
    }
  },
}
</script>
